import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __moduleExports as propTypes } from '../../node_modules/prop-types/index.js';
import React, { useMemo, useRef, useState, useEffect } from 'react';
import useDebounce$1 from '../../../../cinnamon-core/es/components/utility/useDebounce.js';

var DEFAULT_BATCH_SIZE = 20;

var VirtualizedListBatch = function VirtualizedListBatch(_ref) {
  var _placeholderHeight$cu;

  var render = _ref.render,
      Component = _ref.component,
      initialHeight = _ref.initialHeight,
      visibleMargin = _ref.visibleMargin,
      root = _ref.root;
  var ref = useRef(null);
  var placeholderHeight = useRef(undefined);
  var hideCallbackId = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var debouncedSetVisible = useDebounce$1(setVisible, 100);
  useEffect(function () {
    if (!ref.current) return;
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          entry = _ref3[0];

      if (!entry.isIntersecting && ref.current) {
        // store the rendered height to better accommodate for variable height items
        placeholderHeight.current = ref.current.offsetHeight;
      }

      if (entry.isIntersecting) {
        var _window;

        if (hideCallbackId.current !== null && (_window = window) !== null && _window !== void 0 && _window.cancelIdleCallback) {
          window.cancelIdleCallback(hideCallbackId.current);
        }

        debouncedSetVisible(true);
      } else {
        var _window2;

        if ((_window2 = window) !== null && _window2 !== void 0 && _window2.requestIdleCallback) {
          debouncedSetVisible.cancel();
          hideCallbackId.current = window.requestIdleCallback(function () {
            return setVisible(false);
          }, {
            timeout: 1000
          });
        } else {
          debouncedSetVisible(false);
        }
      }
    }, {
      root: root,
      rootMargin: typeof visibleMargin === "number" ? "".concat(visibleMargin, "px 0px ").concat(visibleMargin, "px 0px") : undefined
    });
    observer.observe(ref.current);
    return function () {
      observer.disconnect();
    };
  }, [ref, visibleMargin, root]);
  var style = visible ? {} : {
    height: (_placeholderHeight$cu = placeholderHeight.current) !== null && _placeholderHeight$cu !== void 0 ? _placeholderHeight$cu : initialHeight
  };
  return /*#__PURE__*/React.createElement(Component, {
    ref: ref,
    style: style
  }, visible && render());
};

VirtualizedListBatch.propTypes = {
  render: propTypes.func.isRequired,
  component: propTypes.oneOfType([propTypes.elementType, propTypes.string]).isRequired,
  initialHeight: propTypes.oneOfType([propTypes.number, propTypes.string]),
  visibleMargin: propTypes.number,
  root: propTypes.oneOfType([propTypes.element, propTypes.any, propTypes.oneOf([null])])
};

var VirtualizedList = function VirtualizedList(_ref4) {
  var totalItems = _ref4.totalItems,
      renderItems = _ref4.renderItems,
      _ref4$itemHeight = _ref4.itemHeight,
      itemHeight = _ref4$itemHeight === void 0 ? 0 : _ref4$itemHeight,
      visibleMargin = _ref4.visibleMargin,
      _ref4$batchSize = _ref4.batchSize,
      batchSize = _ref4$batchSize === void 0 ? DEFAULT_BATCH_SIZE : _ref4$batchSize,
      _ref4$batchComponent = _ref4.batchComponent,
      batchComponent = _ref4$batchComponent === void 0 ? "div" : _ref4$batchComponent,
      root = _ref4.root;
  var batches = useMemo(function () {
    var chunks = [];

    var _loop = function _loop(i) {
      var itemCount = Math.min(batchSize, totalItems - i);
      chunks.push({
        key: i,
        component: batchComponent,
        root: root,
        visibleMargin: visibleMargin,
        initialHeight: typeof itemHeight === "number" ? itemHeight * itemCount : "calc(".concat(itemHeight, " * ").concat(itemCount, ")"),
        render: function render() {
          return renderItems(i, i + itemCount);
        }
      });
    };

    for (var i = 0; i < totalItems; i += batchSize) {
      _loop(i);
    }

    return chunks;
  }, [totalItems, renderItems, itemHeight, visibleMargin, batchSize, batchComponent, root]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, batches.map(function (b) {
    return /*#__PURE__*/React.createElement(VirtualizedListBatch, b);
  }));
};

VirtualizedList.propTypes = {
  totalItems: propTypes.number.isRequired,
  renderItems: propTypes.func.isRequired,
  itemHeight: propTypes.oneOfType([propTypes.number, propTypes.string]),
  visibleMargin: propTypes.number,
  batchSize: propTypes.number,
  batchComponent: propTypes.oneOfType([propTypes.elementType, propTypes.string]),
  root: propTypes.oneOfType([propTypes.element, propTypes.any, propTypes.oneOf([null])])
};
var VirtualizedList$1 = VirtualizedList;

export { VirtualizedList$1 as default };
